/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesOrderItemAvailabilityTotalSummary
 */
export interface SalesOrderItemAvailabilityTotalSummary {
    /**
     * 
     * @type {SalesOrderItemAvailabilityTotalSummaryStatusEnum}
     * @memberof SalesOrderItemAvailabilityTotalSummary
     */
    status: SalesOrderItemAvailabilityTotalSummaryStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilityTotalSummary
     */
    totalQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof SalesOrderItemAvailabilityTotalSummary
     */
    totalAmount: number;
}


/**
 * @export
 */
export const SalesOrderItemAvailabilityTotalSummaryStatusEnum = {
    InStock: 'IN_STOCK',
    InStockOverdue: 'IN_STOCK_OVERDUE',
    InStockNotReleased: 'IN_STOCK_NOT_RELEASED',
    Incoming: 'INCOMING',
    InPreorder: 'IN_PREORDER',
    OnRequest: 'ON_REQUEST'
} as const;
export type SalesOrderItemAvailabilityTotalSummaryStatusEnum = typeof SalesOrderItemAvailabilityTotalSummaryStatusEnum[keyof typeof SalesOrderItemAvailabilityTotalSummaryStatusEnum];


/**
 * Check if a given object implements the SalesOrderItemAvailabilityTotalSummary interface.
 */
export function instanceOfSalesOrderItemAvailabilityTotalSummary(value: object): value is SalesOrderItemAvailabilityTotalSummary {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('totalQuantity' in value) || value['totalQuantity'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function SalesOrderItemAvailabilityTotalSummaryFromJSON(json: any): SalesOrderItemAvailabilityTotalSummary {
    return SalesOrderItemAvailabilityTotalSummaryFromJSONTyped(json, false);
}

export function SalesOrderItemAvailabilityTotalSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesOrderItemAvailabilityTotalSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'totalQuantity': json['totalQuantity'],
        'totalAmount': json['totalAmount'],
    };
}

export function SalesOrderItemAvailabilityTotalSummaryToJSON(json: any): SalesOrderItemAvailabilityTotalSummary {
    return SalesOrderItemAvailabilityTotalSummaryToJSONTyped(json, false);
}

export function SalesOrderItemAvailabilityTotalSummaryToJSONTyped(value?: SalesOrderItemAvailabilityTotalSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'totalQuantity': value['totalQuantity'],
        'totalAmount': value['totalAmount'],
    };
}

